import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { isTouch } from '../_app/cuchillo/core/Basics';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

const SWIPE_MIN = 50;

class ScrollItem__ProductTabs extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
        this._tabs = [];
        this._activeIndex = 0;
        this._swipe = { x: 0, y: 0, active: false };

        const links = this.item.querySelectorAll('.link-tab');
        for (let i = 0, j = links.length; i < j; i++) {
            this._tabs.push(new ScrollItem__ProductTabs__Tab(links[i]));
        }

        Interaction.addListener('data-tab', (e) => {
            const index = Number(e.target?.dataset?.index);
            if (Number.isNaN(index)) return;
            this.goTo(index);
        }, 'ProductTabs');

        this._active = this._tabs[0];
        this._active?.show();

        // Native swipe — Hammer is not in the project; keep dependency-free
        this._swipeRoot = GetBy.selector('.product-tabs__tabs-content', this.item)[0] || this.item;
        if (isTouch && this._swipeRoot && this._tabs.length > 1) {
            this._onTouchStart = (e) => {
                const t = e.touches?.[0];
                if (!t) return;
                this._swipe = { x: t.clientX, y: t.clientY, active: true };
            };
            this._onTouchEnd = (e) => {
                if (!this._swipe.active) return;
                this._swipe.active = false;
                const t = e.changedTouches?.[0];
                if (!t) return;
                const dx = t.clientX - this._swipe.x;
                const dy = t.clientY - this._swipe.y;
                if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
                if (dx < 0) this.next();
                else this.prev();
            };
            this._swipeRoot.addEventListener('touchstart', this._onTouchStart, { passive: true });
            this._swipeRoot.addEventListener('touchend', this._onTouchEnd, { passive: true });
        }
    }

    goTo(index) {
        const i = Math.max(0, Math.min(this._tabs.length - 1, index));
        if (i === this._activeIndex || !this._tabs[i]) return;
        this._active?.hide();
        this._activeIndex = i;
        this._active = this._tabs[i];
        this._active.show();
    }

    next() {
        this.goTo(this._activeIndex + 1);
    }

    prev() {
        this.goTo(this._activeIndex - 1);
    }

    dispose() {
        super.dispose();
        Interaction.removeListener('ProductTabs');
        if (this._swipeRoot && this._onTouchStart) {
            this._swipeRoot.removeEventListener('touchstart', this._onTouchStart);
            this._swipeRoot.removeEventListener('touchend', this._onTouchEnd);
        }
        this._tabs?.forEach((tab) => tab.dispose());
        this._tabs = null;
        this._swipeRoot = null;
        this._active = null;
    }
}

class ScrollItem__ProductTabs__Tab {
    constructor(__linkTab) {
        this._linkTab = __linkTab;
        this._dom = GetBy.id(this._linkTab.dataset.tab);
    }

    show() {
        this._linkTab.setAttribute('aria-selected', 'true');
        gsap.to(this._dom, {
            opacity: 1,
            duration: .2,
            ease: 'power2.inOut',
            onStart: () => {
                this._dom.setAttribute('aria-selected', 'true');
            }
        });
    }

    hide() {
        this._linkTab.setAttribute('aria-selected', 'false');
        gsap.to(this._dom, {
            opacity: 0,
            duration: .1,
            ease: 'power2.inOut',
            onComplete: () => {
                this._dom.setAttribute('aria-selected', 'false');
            }
        });
    }

    dispose() {
        this._linkTab = null;
        this._dom = null;
    }
}

Scroll._registerClass('ProductTabs', ScrollItem__ProductTabs);

export default ScrollItem__ProductTabs;
